import math from "core/math";
import { default as correctShift } from "./correctShift.js";
import { default as changeViewportScale } from "./changeViewportScale.js";
import { getEnabledElement } from "component/toolManager/enabledElements.js";
import CustomEvent from "core/customEvent/index";
import Config from "config";

class ZoomTool {
  constructor() {
    this.invert = false;
    this.maxScale = 20.0;
    this.minScale = 0.25;
    this.preventZoomOutsideImage = false;
  }
  onMouseDrag = (evt) => {
    const eventData = evt.detail;
    const { element: enabledElement } = eventData;

    const invert = this.invert;
    const maxScale = this.maxScale;
    const minScale = this.minScale;

    const deltaY = evt.detail.deltaPoints.page.y;
    const ticks = invert ? -deltaY / 100 : deltaY / 100;
    const [startX, startY, imageX, imageY] = [
      evt.detail.startPoints.page.x,
      evt.detail.startPoints.page.y,
      evt.detail.startPoints.image.x,
      evt.detail.startPoints.image.y,
    ];

    // Calculate the new scale factor based on how far the mouse has changed
    const updatedViewport = changeViewportScale(
      enabledElement.viewport,
      ticks,
      {
        maxScale,
        minScale,
      }
    );
    enabledElement.viewport.scale = updatedViewport.scale;
    enabledElement.needsRedraw = true;

    // Now that the scale has been updated, determine the offset we need to apply to the center so we can
    // Keep the original start location in the same position
    const newCoords = math.coordinate.pageToPixel(
      enabledElement.element,
      startX,
      startY
    );

    // The shift we will use is the difference between the original image coordinates of the point we've selected
    // And the image coordinates of the same point on the page after the viewport scaling above has been performed
    // This shift is in image coordinates, and is designed to keep the target location fixed on the page.
    let shift = {
      x: imageX - newCoords.x,
      y: imageY - newCoords.y,
    };

    // Correct the required shift using the viewport rotation and flip parameters
    shift = correctShift(shift, updatedViewport);

    // Apply the shift to the Viewport's translation setting
    enabledElement.viewport.translation.x -= shift.x;
    enabledElement.viewport.translation.y -= shift.y;

    // Zoom 변경에 따른 이벤트 발생
  };
  onMouseUp = (evt) => {
    const eventData = evt.detail;
    const { element: enabledElement } = eventData;
    var elementStub = getEnabledElement(enabledElement.element);
    /**
     * 1x1 포커스 모드일때는 Zoom을 동기화 하지 않는다.
     */
    // eslint-disable-next-line no-unused-expressions
    let focusDCMViewIdx = Config.rootStore.gridLayoutStore.getFocusOneDCMViewIdx();
    if (focusDCMViewIdx !== -1) {
      return;
    }
    CustomEvent.triggerEvent(
      enabledElement.element,
      CustomEvent.EVENTS.PAN_ZOOM_CHANGED,
      elementStub
    );
  };
}

// Module exports
export default ZoomTool;
